import { mapKeys, pick, toString, upperFirst } from 'lodash';
import { AnalyticsTypes } from '../../../middleware/google-analytics';
import { BOOKING_SECTION_KEY } from '../BookingSection/constants';
import { EVENT_INITIATORS, INTERACTION_TYPES, TARGETS } from '../../../EventTrackingConstants';
import { PROFILE_GA_CATEGORY } from '../../constants';

export const ActionTypes = {
    TRACK_TIMESGRID_CLICK_TIME: `${BOOKING_SECTION_KEY}/TRACK_TIMESGRID_CLICK_TIME`,
    TRACK_TIMESGRID_CLICK_NEXT: `${BOOKING_SECTION_KEY}/TRACK_TIMESGRID_CLICK_NEXT`,
    TRACK_TIMESGRID_CLICK_PREV: `${BOOKING_SECTION_KEY}/TRACK_TIMESGRID_CLICK_PREV`,
    TRACK_TIMESGRID_CLICK_MORE: `${BOOKING_SECTION_KEY}/TRACK_TIMESGRID_CLICK_MORE`,
    TRACK_TIMESGRID_CLICK_NEXT_AVAILABLE: `${BOOKING_SECTION_KEY}/TRACK_TIMESGRID_CLICK_NEXT_AVAILABLE`,
    TRACK_TIMESGRID_LOADED: `${BOOKING_SECTION_KEY}/TRACK_TIMESGRID_LOADED`,
};

export const trackTimesgridClickTime = () => ({
    type: ActionTypes.TRACK_TIMESGRID_CLICK_TIME,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Time Slot',
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.BOOK_AN_APPOINTMENT,
                Component: TARGETS.TIMESGRID,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.TIMESGRID_TIMESLOT,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click appointment time',
            },
        },
    },
});

export const trackTimesgridClickNext = () => ({
    type: ActionTypes.TRACK_TIMESGRID_CLICK_NEXT,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Next Week',
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.BOOK_AN_APPOINTMENT,
                Component: TARGETS.TIMESGRID,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.TIMESGRID_NEXT_DAYS_ARROW,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click right arrow',
            },
        },
    },
});

export const trackTimesgridClickPrev = () => ({
    type: ActionTypes.TRACK_TIMESGRID_CLICK_PREV,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Previous Week',
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.BOOK_AN_APPOINTMENT,
                Component: TARGETS.TIMESGRID,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.TIMESGRID_PREV_DAYS_ARROW,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click left arrow',
            },
        },
    },
});

export const trackTimesgridClickMoreTimes = () => ({
    type: ActionTypes.TRACK_TIMESGRID_CLICK_MORE,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click More Times',
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.BOOK_AN_APPOINTMENT,
                Component: TARGETS.TIMESGRID,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.TIMESGRID_MORE_TIMES,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click more times',
            },
        },
    },
});

export const trackTimesgridClickNextAvailable = () => ({
    type: ActionTypes.TRACK_TIMESGRID_CLICK_NEXT_AVAILABLE,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Next Availability',
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.BOOK_AN_APPOINTMENT,
                Component: TARGETS.TIMESGRID,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.TIMESGRID_NEXT_AVAILABLE,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: 'click next availability',
            },
        },
    },
});

export const trackTimesgridLoaded = tgState => ({
    type: ActionTypes.TRACK_TIMESGRID_LOADED,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Timesgrid Loaded',
            label: toString(tgState.isExistingPatient),
            data: {
                Component: TARGETS.TIMESGRID,
                Element: TARGETS.TIMESGRID,
                EventDetails: pick(mapKeys(tgState, (val, key) => upperFirst(key)), [
                    'DirectoryId',
                    'DoctorLocationId',
                    'InsuranceCarrier',
                    'InsurancePlan',
                    'IsExistingPatient',
                    'ProcedureId',
                    'Widget',
                ]),
                Initiator: EVENT_INITIATORS.SYSTEM,
                InteractionType: INTERACTION_TYPES.UPDATE,
                Section: TARGETS.BOOK_AN_APPOINTMENT,
            },
        },
    },
});
